// Pages that only exist in Spanish (real legal text — not machine-translated
// without review). Language switching on these pages always lands on /en home.
export const LEGAL_ONLY_PATHS = [
  '/aviso-legal',
  '/politica-privacidad',
  '/canal-responsable',
]

export const getLangFromPath = (pathname) =>
  pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'es'

export const stripLangPrefix = (pathname) => {
  if (pathname === '/en') return '/'
  if (pathname.startsWith('/en/')) return pathname.slice(3)
  return pathname
}

// Builds the href for a translatable internal path in the given language.
export const withLang = (path, lang) => {
  if (lang !== 'en') return path
  return path === '/' ? '/en' : `/en${path}`
}

export const isLegalOnlyPath = (pathname) =>
  LEGAL_ONLY_PATHS.includes(stripLangPrefix(pathname))
